import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { workflowSchema } from '../models/workflow.schema';
import { workflowsListQuerySchema } from './list.schema';

export type WorkflowsListQuery = Partial<{
  id: ID | ID[];
}> &
  PaginationQuery;

export const list = (query: WorkflowsListQuery = {}) => {
  return {
    endpoint: `/workflows`,
    method: 'GET',
    responseSchema: listResponse(workflowSchema),
    query: { ...query, includeTotal: true },
    querySchema: workflowsListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
